<script lang="ts">
import { defineComponent, reactive, watch, computed } from '@vue/composition-api';
import { useAppLoaderModule } from '@/store/global/appComponents/appLoader';

export default defineComponent({
    name: 'AppLoader',
    props: {},
    setup() {
        const store = useAppLoaderModule();

        const storeProps = computed(() => ({
            isLoading: store.state.isLoading,
            delay: store.state.delay,
        }));

        const state = reactive({
            showLoading: false,
        });

        watch(
            () => [storeProps.value.isLoading, storeProps.value.delay],
            () => {
                if (storeProps.value.isLoading) {
                    setTimeout(() => {
                        if (storeProps.value.isLoading) {
                            state.showLoading = true;
                        }
                    }, storeProps.value.delay);
                } else {
                    state.showLoading = false;
                }
            },
            { immediate: true }
        );

        return {
            state,
            storeProps,
        };
    },
});
</script>

<template>
  <v-overlay :value="state.showLoading" z-index="1001">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
</template>
